import { useEffect, useRef, useState } from "react";

//interfaces
import { ISimpleTableRows } from "../../../../interfaces/tables/ISimpleTable";
import { Direction } from "../../../../interfaces/toggles/IToggle";

//hooks
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";



const UseSimpleTable = (tableRows: ISimpleTableRows[], isInfiniteScroll: boolean, getMoreContent: any, maxContentLength?: number, noDataMessage?: string, infiniteScrollFetchCondition?: boolean) => {
    const [rowContent, setRowContent] = useState<ISimpleTableRows[]>([]);
    const [openMenu, setOpenMenu] = useState<boolean>(false);
    const [controlIndex, setControlIndex] = useState<number | undefined>(undefined);
    const [hoverIndex, setHoverIndex] = useState<number | null>(null);
    const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const [defaultSortIsUnchecked, setDefaultSortIsUnchecked] = useState<boolean>(false)

    const infiniteScrollRef = useInfiniteScroll(getMoreContent, infiniteScrollFetchCondition ?? false) ?? undefined;
    const displayedContent = isInfiniteScroll ? rowContent : rowContent.slice(0, maxContentLength);
    const noContentMessage = noDataMessage ?? "No data found.";
    const showNoContentMessage = !tableRows || tableRows.length < 1;
    const hasControlsColumn = hasControls(rowContent);
    const [toggleDirections, setToggleDirections] = useState<{ [key: number]: Direction }>({});
    const handleToggleDirection = (columnIndex: number, direction: Direction) => {
        setToggleDirections(prev => {
            const newDirections = { ...prev };
            Object.keys(newDirections).forEach(key => {
                newDirections[parseInt(key)] = Direction.BOTH;
            });
            newDirections[columnIndex] = direction;
            return newDirections;
        });
    };

    useEffect(() => {
        setRowContent(tableRows);
    }, [tableRows]);

    useEffect(() => {
        if (infiniteScrollFetchCondition && isInfiniteScroll) {
            setIsLoadingMore(true);
        } else {
            setIsLoadingMore(false);
        }
    }, [isInfiniteScroll, infiniteScrollFetchCondition])

    function moveRow(dragIndex: number, hoverIndex: number, isPageChange: boolean) {
        const dragRow = rowContent[dragIndex];
        const updatedRowContent = [...rowContent];
        updatedRowContent.splice(dragIndex, 1);
    
        if (!isPageChange) {
            updatedRowContent.splice(hoverIndex, 0, dragRow);
        }

        setRowContent(updatedRowContent);
        setHoverIndex(null);
    };

    function hasControls(rows: ISimpleTableRows[]): boolean {
        return rows.some(row => 
          row?.controls?.some(control => 
            control?.content !== undefined && control.content !== null
          )
        );
    }

    return { rowContent, noContentMessage, showNoContentMessage, infiniteScrollRef, displayedContent, hasControlsColumn, controlIndex, setControlIndex, toggleDirections, handleToggleDirection, containerRef, setHoverIndex, hoverIndex, moveRow, openMenu, setOpenMenu, defaultSortIsUnchecked, setDefaultSortIsUnchecked, isLoadingMore};
};

export default UseSimpleTable;